import BaseFeature from '../../foundation/base/base';
import { isDev } from '../../foundation/utilities/development';

class GoalTracker extends BaseFeature {
	constructor(element) {
		super(element);
		this.el = element;
		this.endpoint = this.el.getAttribute('data-endpoint');
		this.id = this.el.getAttribute('data-id');
		this.url = this.el.getAttribute('href');
		this.target = this.el.getAttribute('target');
		this.addEventListeners();
	}

	addEventListeners() {
		this.el.addEventListener('click', (e) => {
			e.preventDefault();
			this.trackGoal();
		});
	}

	trackGoal() {
		if (!this.endpoint) {
			this.log('Tracking endpoint is undefined');
			this.navigateToHref();
			return;
		}
		if (!this.id) {
			this.log('Goal ID is undefined');
			this.navigateToHref();
			return;
		}

		this.log(`Tracking goal:${this.id}`);
		fetch(
			this.endpoint, {
				method: 'POST',
				mode: isDev ? 'cors' : 'same-origin',
				headers: {
					'Content-Type': 'Application/json; charset=utf-8'
				},
				body: JSON.stringify({ id: this.id })
			})
			.then((response) => {
				GoalTracker.handleErrors(response);
				return response.json();
			})
			.then((response) => {
				this.log(response);
				this.navigateToHref();
			})
			.catch((error) => {
				if (error.response) {
					// Client received an error response (5xx, 4xx)
					this.log('Response Error', `${error.response.status}: ${error.response.data}`);
				} else if (error.request) {
					// Client never received a response, or request never left
					this.log('Network error', error.request);
				} else {
					// For debugging purposes if something unexpected goes wrong
					this.log('Unexpected Error', error);
				}
				this.navigateToHref();
			});
	}

	navigateToHref() {
		if (!this.url) return;
		if (this.target) {
			window.open(this.url, this.target);
		} else {
			window.location.href = this.url;
		}
	}

	static handleErrors(response) {
		if (!response.ok) {
			throw Error(response.statusText);
		}
		return response;
	}
}

export default GoalTracker;
